import { RouteSegments } from '../routingClientAdmin.interface';

export const generateScheduleProfileRoute = (id?: number) => {
  const pageUrl = `/${RouteSegments.Root.Config}/${RouteSegments.Config.Profiles}/${RouteSegments.Profiles.Schedule}`;

  if (id) {
    return `${pageUrl}/${id}`;
  }

  return pageUrl;
};
